import _ from 'lodash';
import Part from 'store/bom/Part';

// Parts with the same design data, assignment and state are handled as one decision
function partGroupingKey(part) {
  const assignmentEntries = part.assignment
    ? Object.keys(part.assignment).sort().map((key) => [key, part.assignment[key]])
    : null;

  return JSON.stringify([
    part.footprint?.toLowerCase(),
    part.normalizedFootprint?.toLowerCase(),
    part.comment?.toLowerCase(),
    part.edaMpn?.toLowerCase(),
    part.customerSupplied,
    part.excluded,
    part.isOutOfStock(),
    part.isProblematic(),
    part.getStatus(),
    assignmentEntries,
  ]);
}

export function groupSimilarParts(parts) {
  return _.values(_.groupBy(parts, partGroupingKey));
}

function comparePartNames(a, b) {
  return a.name.localeCompare(b.name, 'en-GB', { numeric: true });
}

function getAssignmentDetails(part) {
  const { assignment } = part;
  if (part.isSmartMatch()) {
    return { mpn: assignment.description, manufacturer: assignment.componentType };
  }

  return _.pick(assignment, ['mpn', 'manufacturer', 'datasheet']);
}

export default class TableEntry {
  constructor(data) {
    Object.assign(this, data);
  }

  static createFromParts(parts) {
    const sortedParts = [...parts].sort(comparePartNames);
    const [part] = sortedParts;
    const { assignment, priceCents } = part;
    const assigned = part.isPhysicalPart() || part.isSmartMatch();
    const status = part.getStatus();

    return new TableEntry({
      ...getAssignmentDetails(part),
      id: sortedParts.map((p) => p.id).join('_'),
      name: sortedParts.map((p) => p.name).join(', '),
      parts: sortedParts,
      comment: part.comment,
      edaMpn: part.edaMpn,
      footprint: part.footprint || '-',
      normalizedFootprint: part.normalizedFootprint,
      status,
      statusPriority: Part.STATUS_PRIORITY[status],
      sourcing: part.getSourcing(),
      physicalPart: part.isPhysicalPart(),
      priceCents: assigned && priceCents ? priceCents * sortedParts.length : null,
      availability: assigned ? part.availability : null,
      assignedFootprint: assigned ? assignment.assignedFootprint : null,
      mismatchedFootprint: assigned ? assignment.mismatchedFootprint : null,
    });
  }
}
